module.exports = __webpack_public_path__ + "img/np.cf2556d9.svg";